<template>
  <div>
    <div class="header">
      <div class="header-content">
        <div class="logo">
          <img @click="handleLogoClick" src="@/assets/logo.png" alt="">
        </div>
        <div class="navbar"> </div>
        <!-- <div class="options">
          <span class="sign-in">登录</span>
          <span class="sign-up">注册</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: [""],
  data() {
    return {};
  },

  created() {},

  methods: {
    handleLogoClick() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "../style/index.scss";
</style>


// WEBPACK FOOTER //
// src/components/Header.vue